export default __webpack_public_path__ + "static/media/headshot.c9c0ec2a.jpg";